import { useAdVehicles } from '@backoffice-frontend/ad-operations'
import { useRemoteOperationsAreaOperatorRole } from '@backoffice-frontend/ad-remote-operations-area'
import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'
import { getHandlingOperatorForRole } from './AdAlertFeedCard/utils'

/**
 * The source of truth for "handling an alert", which drives disabling the
 * on/off-duty toggle.
 */
export const useIsHandlingAlert = (): boolean => {
  const { vehicles } = useAdVehicles()
  const role = useRemoteOperationsAreaOperatorRole()
  const { user } = useBackofficeLoggedInUser()

  if (!user?.id) return false

  return vehicles.some(
    vehicle => getHandlingOperatorForRole(vehicle, role)?.id === user.id,
  )
}
